/**
 * Sends a POST request to sort the modules.
 * 
 * @param {object} sm - Object representing the current state of the rack, which will be sent in the request.
 * @returns {Promise<object|null>} - Returns a Promise that resolves to the sorted modules if the request is successful, or null if there is an error.
 */
import toast from "react-hot-toast";


export const handleSubmit = async (sm) => {
  try {
    const response = await fetch('https://d10xp9krdkfyts.cloudfront.net/api/ordenateModules', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ currentRack: sm }),
    });

    const data = await response.json();

    if (data.status === 'success') {
      return data.ordered_modules;
    } else {
      toast.error(data.message);
      return null;
    }
  } catch (error) {
    toast.error('Unable to fetch data from server');
    console.error('Error:', error);
    return null;
  }
};

/**
 * Sends a POST request to configure the selected module.
 * 
 * @param {object} sm - Object representing the selected modules, which will be sent in the request.
 * @returns {Promise<object|null>} - Returns a Promise that resolves to the sorted modules if the request is successful, or null if there is an error.
 */
export const handleSubmitSubModule = async (sm) => {
  try {
    const response = await fetch('https://d10xp9krdkfyts.cloudfront.net/api/configureModule', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ selected_modules: sm }),
    });

    const data = await response.json();

    if (data.status === 'success') {
      return data.ordered_modules;
    } else {
      toast.error(data.message);
      return null;
    }
  } catch (error) {
    toast.error('Unable to fetch data from server');
    console.error('Error:', error);
    return null;
  }
};

/**
 * Sends the module configuration via email.
 * 
 * @param {string} email - The email address to which the configuration will be sent.
 * @param {object} selectedModules - Object representing the selected modules for the configuration.
 * @param {string} deliveryTime - Delivery time for the configuration.
 * @param {number} price - Price of the configuration.
 * @returns {Promise<object>} - Returns a Promise that resolves to the response of the request. Throws an exception in case of error.
 * @throws {Error} - Throws an exception if an error occurs during the request.
 */
export const sendConfiguration = async (email, selectedModules, deliveryTime, price) => {
  try {
    const response = await fetch('https://d10xp9krdkfyts.cloudfront.net/api/configuratorEGSE/sendConfiguration', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, selectedModules, price, deliveryTime }),
    });

    if (!response.ok) {
      console.error(`HTTP error! Status: ${response.status}, Message: ${response.statusText}`);
      return { status: 'error', message: 'Failed to send configuration, server responded with an error.' };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error occurred while sending configuration:', error);
    throw error;
  }
};
